/**
 * Converted Lead Job check schedule — the day (counted from contact creation)
 * each check fires on. Check N runs on `CONVERTED_CHECK_DAYS[N - 1]`.
 *
 * DUPLICATE of `apps/ghl-qualifier/src/jobs/converted-lead/schedule.ts`, which
 * owns the real scheduling (the qualifier's Docker build can't share a
 * workspace package). Change both together —
 * `apps/ghl-qualifier/scripts/test-converted-schedule.ts` fails if they drift.
 *
 * Kept import-free so that script can load it outside Vite.
 */

export const CONVERTED_CHECK_DAYS: readonly number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 15, 22, 30, 60,
]

/**
 * Day number for a 1-based check number. Lifecycles that started under the
 * old 8-daily-checks rule line up with the first 8 entries, so their labels
 * are unchanged; anything off the end of the schedule falls back to the
 * check number itself.
 */
export function convertedCheckDay(checkNumber: number): number {
  return CONVERTED_CHECK_DAYS[checkNumber - 1] ?? checkNumber
}
